<template>
    <el-card class="rightPart">
        <activity
         :info="info"
         v-show="!componentItem.type"
         @setActivityData="setActivityData"></activity>
        <items
         :componentItem="componentItem"
         v-show="componentItem.type"
        ></items>
    </el-card>
</template>

<script scoped>
    import activity from './rightComponents/activity'
    import items from './rightComponents/items'
    export default {
        data() {
            return {
            }
        },
        props: {
            info: {
				type: Object,
				default: () => {}
			},
            componentItem: {
				type: Object,
				default: () => {}
			},
        },
        components: {
            items,
            activity
        },
        methods: {
            setActivityData(data) {
                this.$emit('setActivityData', data)
            }
        }
    }
</script>

<style type="text/less" lang="less" scoped>
    .rightPart{
        overflow: auto;
        height: 670px;
    }
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/rightPart.vue